export enum ENGINE_TYPES {
	OVC_HEV = 'OVC_HEV', //PLUGIN HYBRID
	NOVC_HEV = 'NOVC_HEV' //MILD HYBRID
}

export enum EnergyManagementType {
	Pure = 'PURE',
	Weighted = 'WEIGHTED',
	Sustaining = 'SUSTAINING'
}
